import React from "react";

export const Hero = () => {
  return (
    <section
      id="platform"
      data-testid="section-hero"
      className="relative pt-32 pb-24 lg:pt-44 lg:pb-32 overflow-hidden"
    >
      {/* Subtle layered grid */}
      <div className="absolute inset-0 bg-grid-fine opacity-60 radial-fade pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(ellipse 60% 40% at 20% 20%, rgba(0,102,255,0.10), transparent 60%), radial-gradient(ellipse 40% 30% at 80% 80%, rgba(234,179,8,0.04), transparent 60%)",
        }}
      />

      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
        {/* Eyebrow */}
        <div className="reveal mb-8">
          <span className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
            KATLAS Platform
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="reveal font-display text-[40px] sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-5xl font-medium"
          style={{ animationDelay: "0.05s" }}
        >
          Trusted coordination for work that{" "}
          <span className="text-slate-400">crosses organisations.</span>
        </h1>

        <p
          data-testid="hero-supporting-1"
          className="reveal mt-8 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed"
          style={{ animationDelay: "0.15s" }}
        >
          <span className="text-white">KATLAS is a software platform</span>{" "}
          that helps organisations, partners and AI systems complete sensitive
          decisions and handovers without putting everyone&apos;s data in one
          place.
        </p>

        <p
          data-testid="hero-supporting-2"
          className="reveal mt-5 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed"
          style={{ animationDelay: "0.2s" }}
        >
          It keeps evidence with the responsible party, checks who is
          authorised to act, and creates{" "}
          <span className="text-[#EAB308]">
            an auditable record of every request, approval, refusal, handoff
            and escalation.
          </span>
        </p>

        <div
          className="reveal mt-10 flex flex-col sm:flex-row gap-3"
          style={{ animationDelay: "0.28s" }}
        >
          <a
            href="https://authority-journey.katlastechnology.com/"
            data-testid="hero-cta-primary"
            className="cta-primary inline-flex items-center justify-center gap-2 bg-[#0066FF] hover:bg-[#0052CC] text-white px-6 py-3.5 text-sm font-medium rounded-sm transition-transform hover:-translate-y-px"
          >
            See KATLAS in one workflow
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17 17 7M8 7h9v9"/></svg>
          </a>
          <a
            href="https://labs.katlastechnology.com/"
            data-testid="hero-cta-secondary"
            className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white/40 text-white px-6 py-3.5 text-sm font-medium rounded-sm transition-colors"
          >
            Explore a focused pilot
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17 17 7M8 7h9v9"/></svg>
          </a>
        </div>

        <p
          data-testid="hero-compatibility-line"
          className="reveal mt-4 text-[12px] text-slate-500"
          style={{ animationDelay: "0.32s" }}
        >
          Works alongside existing CRM, ERP, workflow, data and AI systems.
        </p>
      </div>
    </section>
  );
};
